export const endpoints = {
  thopSocket: 'websocket/notifications?appType=',
  allProrithmDevices: 'api/ipd/device/mappings',
  vitalAlertSocket: 'websocket?patientId=alert&deviceId=alert_',
  searchPatient: 'api/ipd/prorithm-bed-location-mapping/patient?',
  radiologyFileUpload: 'api/ipd/radiologyFile/upload',
  getRadiologyDocuments: 'api/ipd/radiologyFile/getdocumentIds?',
}
